import { BindingPath } from "../Engine/Core/CoreTypes";

export class BindingPathUtils {
    public static pathToInstance(part1: BindingPath, instance: string): BindingPath {
        return [...part1.split("/"), instance].join("/");
    }
}
